import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SizingIcon from '../../../../../../icons/SizingIcon';
import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerLayoutControlsButton = ({ className, active, onClick }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<SizingIcon />}
      title="Layout"
      onClick={onClick}
    />
  );
};

CardDesignerLayoutControlsButton.propTypes = propTypes;

export default CardDesignerLayoutControlsButton;
